import { defineStore } from "pinia";
import { acceptTVCode, authVia, cancelStripeSubscription, getConnectedDevices, getUserProfile, GetUserSubscriptionStatus, logout, logoutFromDevice, verifyOpt } from "@/Gql/auth.js";
import apolloClient from "../plugins/apollo";
import { AUTHTOKEN, ISACTIVE, isSubscribed, USER,AF } from "@/constants.js";
import { HTTP } from "@/http-common";

export const useAuthStore = defineStore("auth", {
  state: () => {
    return {
      isLoggedin: Boolean, // check user status 
      user: JSON.parse(localStorage.getItem("user")), // user data to be stored 
      token: "",
      phone: "",
      userData: null,
      devices: null

    }
  },// end of state
  getters: {
    getUser: (state) => state.user,
    isAuthenticated: (state) => state.user != undefined,
    getPhone: (state) => state.phone,
    getUserDtata: (state) => state.userData,
    getDevices: (state) => state.devices

  }, //end of getters 
  actions: {
      /**
     * Call OTP API
     * @param {*} msisdn
     * @param {*} subscriptionPackage
     * @returns {Promise} API response
     */

    async callOtpAPI(msisdn,  subscriptionPackage = 'daily', referenceUserId = null) {
      const antiFraudUniqid = localStorage.getItem(AF);

      const payload = {
        msisdn,
        antiFraudUniqid,
        subscriptionPackage,
      };

      if (referenceUserId) {
        payload.referenceUserId = referenceUserId;
      }


      return new Promise((resolve, reject) => {
        HTTP.post("/auth/ksa/unified/init", payload)
          .then((response) => {
          
           
            resolve(response);
          })
          .catch((error) => {
            console.error("Error calling OTP API:", error);
            console.error("Error details:", error.response?.data || error.message);
            reject(error);
          });
      });
    },
  /**
     * Call antifraud API
     * @params package name
     * @returns {Promise} API response
     */
    async callAntifraudAPI(packageName='daily') {
      return new Promise((resolve, reject) => {
        HTTP.get(`/auth/ksa/stc/antifraud?subscriptionPackage=${packageName}`)
          .then((response) => {
            console.log("Antifraud API response:", response);
            resolve(response);
          })
          .catch((error) => {
            console.error("Error calling antifraud API:", error);
            reject(error);
          });
      });
    },
    async authViaAction(id, via) {

      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: authVia,
            variables: {
              input: {
                id: id,
                via: via
              }
            },

          })
          .then((response) => {


            this.setData(authVia)
            resolve(response);
          })
          .catch((error) => {
            this.error = error;
            reject(error);
          });
      });
    },

    async verifyOptAction(id, otp, via) {

      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: verifyOpt,
            variables: {
              input: {
                id: id,
                otp: otp,
                via: via
              }
            },
          })
          .then((response) => {
            const { authViaVerify } = response.data;

            this.setData(authViaVerify)
            resolve(response);
          })
          .catch((error) => {
            this.error = error;
            reject(error);
          });
      });
    },
    async logoutFromDeviceAction(id) {
      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: logoutFromDevice,
            variables: {
              logoutFromDeviceId: id
            },

          })
          .then((response) => {
            if (response.data.logoutFromDevice.success) {
              this.devices = this.devices.filter((device) => device.id !== id)
            }
            resolve(response);
          })
          .catch((error) => {
            this.error = error;
            reject(error);
          });
      });
    },
    async cancelStripeSubscriptionAction() {
      const user = localStorage.getItem(USER);
      if (!user) return;

      const userId = JSON.parse(user)?.id;


      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: cancelStripeSubscription,
            variables: {
              input: {
                user_id: userId
              }
            },

          })
          .then((response) => {

            resolve(response);
          })
          .catch((error) => {
            this.error = error;
            reject(error);
          });
      });
    },
    async logout() {

      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: logout,


          })
          .then((response) => {
            // const { revokeAccessToken } = response.data;
            // if (revokeAccessToken?.success) {
            this.wipeUserData();
            // }
            resolve(response);
          })
          .catch((error) => {
            this.error = error;
            reject(error);
          });
      });
    },


    /**
     * login user for authentication purpose 
     */
    async verifyTvPinCode(userID, code) {
      return new Promise((resolve, reject) => {
        apolloClient
          .mutate({
            mutation: acceptTVCode,
            variables: {
              userId: userID, // Corrected variable name
              code
            },
          })
          .then((response) => {
            console.log(response.data.acceptTVCode);
            resolve(response);
          })
          .catch((error) => {
            this.error = error;
            reject(error);
          });
      });
    },
    async checkStatus() {
      console.log("Checking subscription status...");
      await apolloClient
        .query({
          query: GetUserSubscriptionStatus,

        }).then(async res => {
          if (res.data.getUserSubscriptionStatus.is_active) {
            this.isLoggedin = true;
            localStorage.setItem(isSubscribed, true);
          } else {
            this.isLoggedin = false;
            localStorage.setItem(isSubscribed, false);
          }
        })
        .catch(error => {
          this.error = error
        })
    },
    async getUserProfileAction() {
      await apolloClient
        .query({
          query: getUserProfile,

        }).then(async res => {
          if (res.data.userProfile.success) {
            this.userData = res.data.userProfile.subscription;
          }
        })
        .catch(error => {
          this.error = error
        })
    },
    async getConnectedDevicesAction() {
      await apolloClient
        .query({
          query: getConnectedDevices,

        }).then(async res => {
          if (res.data.userConnectedDevices) {
            this.devices = res.data.userConnectedDevices.data;
          }
        })
        .catch(error => {
          this.error = error
        })
    },

    /**
     * 
     * @param {*} authViaVerify 
     */

    async setData(authViaVerify) {
      if (authViaVerify.success) {

        window.localStorage.setItem(USER, JSON.stringify(authViaVerify.user));
        window.localStorage.setItem(AUTHTOKEN, authViaVerify.token);
        window.localStorage.setItem(ISACTIVE, authViaVerify.token ? true : false);

      } else {
        this.wipeUserData()
      }

    },

    /**
     * uri /bravo/otp
     * @param {*} phoneNumber 
     * @returns response json
     */

    async bravoPay(phoneNumber, phoneMetadata) {
      localStorage.setItem("bravoAccountId", phoneNumber);
      localStorage.setItem("countryCode", JSON.stringify(phoneMetadata));
      const packageName = JSON.parse(localStorage.getItem("selectedPlan"));
      const price = packageName?.price;
      return new Promise((resolve, reject) => {
        HTTP.post('/bravo/otp', {
          bravoAccountId: phoneNumber,
          amount: price,
          phoneMetadata: phoneMetadata,

        })
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            console.error("Error in bravoPay:", error);
            reject(error);
          });
      });
    },

    /**
    * uri /bravo/otp
    * @param {*} otp 
    * @returns response json
    */

    async bravoConfirmation(otp) {
      const bravoAccountId = localStorage.getItem("bravoAccountId");
      const phoneMetadata = JSON.parse(localStorage.getItem("countryCode"));
      const packageName = JSON.parse(localStorage.getItem("selectedPlan"));
      const plan_uuid = packageName?.plan_uuid;
      const price = packageName?.price;
      return new Promise((resolve, reject) => {
        HTTP.post('/bravo/confirm', {
          bravoAccountId: bravoAccountId,
          amount: price,
          otp: otp,
          phoneMetadata: phoneMetadata,
          plan_uuid: plan_uuid
        })
          .then(response => {
            if (response.data.success) {
              localStorage.setItem(AUTHTOKEN, response.data.token);
              localStorage.setItem(USER, JSON.stringify(response.data.user));
              localStorage.setItem(ISACTIVE, response.data.token ? true : false);
            }
            resolve(response);

          })
          .catch(error => {
            console.error("Error in bravoPay:", error);
            reject(error);
          });
      });
    },

    /**
     * https://api.nasna.tv/api/coupon/redeem
     * @param {*} couponCode 
     * @returns response json
     * "code" : "test1",
      "userId" : "cl8lhm6es0000daqn9jly6t65",
      "issue_token" : true
     */

    async redeemCoupon(couponCode, issue_token = true) {
      const userString = localStorage.getItem(USER);
      let user_id = null;
      
      if (userString) {
        try {
          const user = JSON.parse(userString);
          user_id = user?.id;
          issue_token = false;
        } catch (error) {
          console.error('Error parsing user data from localStorage:', error);
          user_id = localStorage.getItem('user_id_sub');
          issue_token = true;
        } 
      } else {
        issue_token = true;
        user_id = localStorage.getItem('user_id_sub');
      }

      if (!user_id) {
        console.warn('No user ID found for coupon redemption');
        return Promise.reject(new Error('User ID is required for coupon redemption'));
      }
      return new Promise((resolve, reject) => {
        HTTP.post('/coupon/redeem', {
          code: couponCode,
          userId: user_id,
          issue_token: issue_token
        })
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            console.error("Error in redeemCoupon:", error);
            reject(error);
          });
      });
    },

    /**
     * URL: https://api.nasna.tv/api/v1/auth/temp_web_token/access_token
     * @param {*} temp_web_token
     * @param {*} user_id
     * @returns response json
     */
    async getTokenAccess(temp_web_token, user_id) {
      const User = JSON.parse(localStorage.getItem(USER));
   
      if (User?.id === user_id) {
        console.log("DEBUG: User IDs match, no need to get new token.");
        return;
      } 

      return new Promise((resolve, reject) => {
        HTTP.post('/v1/auth/temp_web_token/access_token', {
          temp_token: temp_web_token,
          userId: user_id
        })
          .then(response => {
            if (response.data.success) {
              localStorage.setItem(AUTHTOKEN, response.data.token);
              localStorage.setItem(ISACTIVE, response.data.token ? true : false);
              localStorage.setItem(USER, JSON.stringify(response.data.user));
            }
            resolve(response);
          })
          .catch(error => {
            console.error("Error in getTokenAccess:", error);
            reject(error);
          });
      });
    },

    /**
     * 
     */

    wipeUserData() {
      window.localStorage.removeItem(USER);
      window.localStorage.removeItem(AUTHTOKEN);
      window.localStorage.removeItem(ISACTIVE);

    },



  }
})